export default "__VITE_ASSET__Yk$vHeBM__"